module.exports = __webpack_public_path__ + "f1ad15db6fe029ba2e6e3e222ae1cd30.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/WW-SAM.svg
// module id = iRSW
// module chunks = 0